import type { ReactNode } from 'react';

export const symbol_transition_push: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M420-160h-53q-12 0-20.5-9t-8.5-21q0-12 9-20.5t21-8.5h52v-521h-52q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h52q24 0 42 18t18 42v520q0 24-18 42t-42 18Zm200 0q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h240q24 0 42 18t18 42v520q0 24-18 42t-42 18H620Zm0-59h240v-521H620v521ZM245-450H70q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-510 70-510h175l-55-55q-9-9-9-21t8.84-21q8.84-9 21-9t21.16 9l107 106q5 5 7 10.13 2 5.14 2 11 0 5.87-2 10.87-2 5-7 10L233-351q-9 9-21.5 9t-21.5-9.39q-9-8.61-9-20.81 0-12.19 9-20.8l55-57Zm375 231v-521 521Z"
		/>
	</svg>
);
